import React from 'react';
import PropTypes from 'prop-types';
import { CMS } from '../../utils/CMS';

export const DoneButton = ({ extraTracking, action }) => {
    const onClickContinue = () => {
        extraTracking();
        action();
    };

    return (
        <div className="odf-space-inner-left-l odf-space-inner-right-l odf-space-inner-top-m odf-space-inner-bottom-l">
            <div className="odf-flex-container-row odf-flex-container-justify-end">
                <div className="odf-flex-item odf-flex-item-sm">
                    <button type="button" className="odf-btn odf-btn-primary" onClick={onClickContinue}>
                        <CMS id="calendar.header.button.done" />
                    </button>
                </div>
            </div>
        </div>
    );
};

DoneButton.propTypes = {
    extraTracking: PropTypes.func,
    action: PropTypes.func,
};

DoneButton.defaultProps = {
    extraTracking: () => {},
    action: () => {},
};
